/**
 * @file Constants related to Print Packages.
 */

/**
 * Digital downloads mode enum.
 *
 * @enum DIGITAL_DOWNLOADS_MODE
 * @type {{NOT_INCLUDED: string, INCLUDED: string, UPSELL: string}}
 */
const DIGITAL_DOWNLOADS_MODE = {
  NOT_INCLUDED: 'NOT_INCLUDED',
  INCLUDED: 'INCLUDED',
  UPSELL: 'UPSELL',
};

const PURCHASED_PRINT_PACKAGE_STATUS = {
  PENDING: 'PENDING',
  SHIPPED: 'SHIPPED',
};

const SOFT_DELETED_FILTER = {
  ALL: 'ALL',
  SOFT_DELETED: 'SOFT_DELETED',
  NON_SOFT_DELETED: 'NON_SOFT_DELETED',
};

export {
  DIGITAL_DOWNLOADS_MODE,
  PURCHASED_PRINT_PACKAGE_STATUS,
  SOFT_DELETED_FILTER,
};
